// extracted by mini-css-extract-plugin
export default {"header":"GreyWaterInfrastructure_header__iQKS4","content":"GreyWaterInfrastructure_content__YDXqA"};